import { Col, Form, FormGroup, Input, Label, Row } from "reactstrap";
import { NumberingWizardPropsType } from "../../../../Type/FormLayoutType";
import { AgreeToTermsAndConditions, BohoMail, ConfirmPassword, Email, EnterConfirmPassword, EnterPassword, EnterYourName, FirstName, Password } from "../../../../Constant";

const BasicInfoForm = ({ basicInputFormValue, getUserData }: NumberingWizardPropsType) => {
  const { email, firstName, password, confirmPassword, agreeTerms } = basicInputFormValue;

  return (
    <Form className="stepper-one g-3 needs-validation custom-input" noValidate>
      <Row>
      <Col sm="6" className="mb-3">
        <Label check>{Email}<span className="txt-danger">*</span></Label>
        <Input onChange={getUserData} value={email} name="email" type="email" placeholder={BohoMail} />
      </Col>
      <Col sm="6" className="mb-3">
        <Label check>{FirstName}<span className="txt-danger">*</span></Label>
        <Input onChange={getUserData} value={firstName} name="firstName" type="text" placeholder={EnterYourName} />
      </Col>
      <Col xs="12" className="mb-3">
        <Label check>{Password}<span className="txt-danger">*</span></Label>
        <Input onChange={getUserData} value={password} name="password" type="password" autoComplete="" placeholder={EnterPassword} />
      </Col>
      <Col xs="12" className="mb-3">
        <Label check>{ConfirmPassword}<span className="txt-danger">*</span></Label>
        <Input onChange={getUserData} value={confirmPassword} name="confirmPassword" type="password" autoComplete="" placeholder={EnterConfirmPassword} />
      </Col>
      <Col xs="12" className="mb-3">
        <FormGroup check>
          <Input id="inputCheckWizard" name="agreeTerms" onChange={getUserData} type="checkbox" checked={agreeTerms} required/>
          <Label className="mb-0" htmlFor="inputCheckWizard" check>{AgreeToTermsAndConditions}</Label>
        </FormGroup>
      </Col>
      </Row>
    </Form>
  );
};

export default BasicInfoForm;
